import React from 'react';

interface HeroProps {
  onContactClick?: () => void;
}

const Hero: React.FC<HeroProps> = ({ onContactClick }) => {
  return (
    <section className="relative h-[80vh] min-h-[600px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 w-full h-full bg-cover bg-center z-0"
        style={{ 
          backgroundImage: `url('https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=1920')`,
          backgroundPosition: 'center center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/80 to-primary-900/50"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 text-white animate-fade-in pt-32">
        <div className="max-w-3xl">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
            From Commercial Spaces to Comfortable Homes
          </h1>
          <p className="text-lg md:text-xl mb-8 text-white/90 max-w-2xl">
            SL Rooms specialises in converting tired offices and mixed-use properties into high-quality, energy-efficient residential units across Surrey, Berkshire, Hampshire, Buckinghamshire, and surrounding areas.
          </p>
          <p className="text-xl md:text-2xl font-serif mb-8 text-accent-400">
            Our mission: 100 new homes in 5 years.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <a
              onClick={(e) => {
                e.preventDefault();
                onContactClick?.();
              }}
              className="px-6 py-3 bg-accent-400 hover:bg-accent-500 text-primary-950 font-medium rounded-md transition-colors duration-300 inline-flex items-center justify-center"
            >
              Work With Us
            </a>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-1">
          <div className="w-1 h-2 bg-white/50 rounded-full animate-scroll"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;